/**
 * Audio mime types supported by nVoq.
 */
export const AudioMimeType = Object.freeze({
  pcm16khz: 'audio/pcm-16khz',
  pcm8khz: 'audio/pcm-8khz',
  ogg: 'audio/ogg',
  webm: 'audio/webm',
});

type AudioMimeTypeKey = keyof typeof AudioMimeType;

/**
 * Audio formats supported by nVoq.
 */
export const AudioFormat: Record<AudioMimeTypeKey, string> = (
  Object.keys(AudioMimeType) as AudioMimeTypeKey[]
).reduce(
  (acc, curr) => {
    const [, audioFormat] = AudioMimeType[curr].split('/');
    acc[curr] = audioFormat;
    return acc;
  },
  {} as Record<AudioMimeTypeKey, string>
);
